/*=============================================== MessagingPage ===============================================*/

import { useState } from "react"
import { Messaging, convertDateShort, getTimeNow } from "tsx-library-julseb"
import type { MessageProps } from "tsx-library-julseb/types"

import { ComponentsLayout } from "components"
import type { ItemType, PropsItemType } from "components"

import { commonProps, iconBoxicon } from "data"

const MessagingPage = () => {
    const [newMessageEmpty, setNewMessageEmpty] = useState<string>("")
    const [emptyArray, setEmptyArray] = useState<MessageProps[]>([])

    const submitEmpty = () => {
        setEmptyArray([
            ...emptyArray,
            {
                type: "sent",
                text: newMessageEmpty,
                date: convertDateShort(new Date()),
                time: getTimeNow(),
            },
        ])
        setNewMessageEmpty("")
    }

    const messagesList: MessageProps[] = [
        {
            type: "received",
            text: "Message received https://julien-sebag.com/",
            date: convertDateShort(new Date()),
            time: "11:15",
        },
        {
            type: "sent",
            text: "Message sent https://julien-sebag.com/",
            date: convertDateShort(new Date()),
            time: "11:17",
        },
        {
            type: "received",
            text: "Message received https://julien-sebag.com/",
            date: convertDateShort(new Date()),
            time: "11:15",
        },
        {
            type: "sent",
            text: "Message sent https://julien-sebag.com/",
            date: convertDateShort(new Date()),
            time: "11:17",
        },
        {
            type: "received",
            text: "Message received https://julien-sebag.com/",
            date: convertDateShort(new Date()),
            time: "11:15",
        },
        {
            type: "sent",
            text: "Message sent https://julien-sebag.com/",
            date: convertDateShort(new Date()),
            time: "11:17",
        },
        {
            type: "received",
            text: "Message received https://julien-sebag.com/",
            date: convertDateShort(new Date()),
            time: "11:15",
        },
        {
            type: "sent",
            text: "Message sent https://julien-sebag.com/",
            date: convertDateShort(new Date()),
            time: "11:17",
        },
        {
            type: "received",
            text: "Message received https://julien-sebag.com/",
            date: convertDateShort(new Date()),
            time: "11:15",
        },
        {
            type: "sent",
            text: "Message sent https://julien-sebag.com/",
            date: convertDateShort(new Date()),
            time: "11:17",
        },
        {
            type: "received",
            text: "Message received https://julien-sebag.com/",
            date: convertDateShort(new Date()),
            time: "11:15",
        },
        {
            type: "sent",
            text: "Message sent https://julien-sebag.com/",
            date: convertDateShort(new Date()),
            time: "11:17",
        },
    ]

    const [newMessage, setNewMessage] = useState<string>("")
    const [messagesArr, setMessagesArr] = useState<MessageProps[]>(messagesList)

    const handleSubmit = () => {
        setMessagesArr([
            ...messagesArr,
            {
                type: "sent",
                text: newMessage,
                date: convertDateShort(new Date()),
                time: getTimeNow(),
            },
        ])
        setNewMessage("")
    }

    const items: ItemType[] = [
        {
            title: "Empty",
            content: (
                <Messaging
                    input={{
                        message: newMessageEmpty,
                        setMessage: setNewMessageEmpty,
                    }}
                    submit={submitEmpty}
                    data={emptyArray}
                />
            ),
            code: 'const [newMessageEmpty, setNewMessageEmpty] = useState("")\nconst [emptyArray, setEmptyArray] = useState([])\n\nconst submitEmpty = () => {\n    setEmptyArray([\n        ...emptyArray,\n        {\n            type: "sent",\n            text: newMessageEmpty,\n            date: convertDateShort(new Date()),\n            time: getTimeNow(),\n        },\n    ])\n    setNewMessageEmpty("")\n}\n\n<Messaging\n    input={{\n        message: newMessageEmpty,\n        setMessage: setNewMessageEmpty,\n    }}\n    submit={submitEmpty}\n    data={emptyArray}\n/>',
            codeTs: 'const [newMessageEmpty, setNewMessageEmpty] = useState<string>("")\nconst [emptyArray, setEmptyArray] = useState<MessageProps[]>([])\n\nconst submitEmpty = () => {\n    setEmptyArray([\n        ...emptyArray,\n        {\n            type: "sent",\n            text: newMessageEmpty,\n            date: convertDateShort(new Date()),\n            time: getTimeNow(),\n        },\n    ])\n    setNewMessageEmpty("")\n}\n\n<Messaging\n    input={{\n        message: newMessageEmpty,\n        setMessage: setNewMessageEmpty,\n    }}\n    submit={submitEmpty}\n    data={emptyArray}\n/>',
        },
        {
            title: "With messages",
            content: (
                <Messaging
                    input={{ message: newMessage, setMessage: setNewMessage }}
                    submit={handleSubmit}
                    button={{ text: "Send" }}
                    data={messagesArr}
                />
            ),
            code: 'const messagesList = [\n    {\n        type: "received",\n        text: "Message received https://julien-sebag.com/",\n        date: convertDateShort(new Date()),\n        time: "11:15",\n    },\n    {\n        type: "sent",\n        text: "Message sent https://julien-sebag.com/",\n        date: convertDateShort(new Date()),\n        time: "11:17",\n    },\n    ...rest\n]\n\nconst [newMessage, setNewMessage] = useState("")\nconst [messagesArr, setMessagesArr] = useState(messagesList)\n\nconst handleSubmit = () => {\n    setMessagesArr([\n        ...messagesArr,\n        {\n            type: "sent",\n            text: newMessage,\n            date: convertDateShort(new Date()),\n            time: getTimeNow(),\n        },\n    ])\n    setNewMessage("")\n}\n\n<Messaging\n    input={{ message: newMessage, setMessage: setNewMessage }}\n    submit={handleSubmit}\n    button={{ text: "Send" }}\n    data={messagesArr}\n/>',
            codeTs: 'const messagesList: MessageProps[] = [\n    {\n        type: "received",\n        text: "Message received https://julien-sebag.com/",\n        date: convertDateShort(new Date()),\n        time: "11:15",\n    },\n    {\n        type: "sent",\n        text: "Message sent https://julien-sebag.com/",\n        date: convertDateShort(new Date()),\n        time: "11:17",\n    },\n    ...rest\n]\n\nconst [newMessage, setNewMessage] = useState<string>("")\nconst [messagesArr, setMessagesArr] = useState<MessageProps[]>(messagesList)\n\nconst handleSubmit = () => {\n    setMessagesArr([\n        ...messagesArr,\n        {\n            type: "sent",\n            text: newMessage,\n            date: convertDateShort(new Date()),\n            time: getTimeNow(),\n        },\n    ])\n    setNewMessage("")\n}\n\n<Messaging\n    input={{ message: newMessage, setMessage: setNewMessage }}\n    submit={handleSubmit}\n    button={{ text: "Send" }}\n    data={messagesArr}\n/>',
        },
    ]

    const propsItems: PropsItemType[] = [
        {
            subtitle: "submit",
            type: "function",
            required: true,
        },
        {
            subtitle: "iconScroll",
            intro: commonProps.addIconCapital,
            type: "string",
            default: iconBoxicon("chevron-down"),
        },
        {
            subtitle: "iconScrollSize",
            type: "number",
            default: "32 * 0.6",
        },
        {
            subtitle: "textDateTime",
            intro: (
                <>
                    This corresponds to the <code>at</code> between date and
                    time.
                </>
            ),
            type: "string",
            default: "at",
        },
        {
            subtitle: "emptyText",
            type: "string",
            default: "No message yet.",
        },
        "separator",
        {
            subtitle: "data",
            type: "array of objects",
            required: true,
        },
        {
            title: (
                <>
                    <code>data</code> object
                </>
            ),
            subtitle: "type",
            type: "string",
            possible: ["received", "sent"],
            required: true,
        },
        {
            subtitle: "text",
            type: "string",
            required: true,
        },
        {
            subtitle: "date",
            type: "string",
        },
        {
            subtitle: "time",
            type: "string",
        },
        "separator",
        {
            subtitle: "input",
            type: "object",
            required: true,
        },
        {
            title: (
                <>
                    <code>input</code> object
                </>
            ),
            subtitle: "message",
            type: "string",
            required: true,
        },
        {
            subtitle: "setMessage",
            type: "function",
            required: true,
        },
        {
            subtitle: "placeholder",
            type: "string",
            default: "Type your message...",
        },
        {
            subtitle: "autoFocus",
            type: "boolean",
        },
        {
            subtitle: "button",
            type: "object",
        },
        {
            title: (
                <>
                    <code>button</code> object
                </>
            ),
            subtitle: "icon",
            intro: (
                <>
                    Only if <code>button.text</code> is not defined.
                </>
            ),
            type: "string",
            default: iconBoxicon("send"),
        },
        {
            subtitle: "text",
            intro: (
                <>
                    Only if <code>button.icon</code> is not defined.
                </>
            ),
            type: "string",
        },
    ]

    return <ComponentsLayout items={items} propsItems={propsItems} />
}

export default MessagingPage
